import { React } from '@/vendor'

export default (props) => (
	<svg width={11} height={20} viewBox="0 0 11 20" {...props}>
		<path d="M2.5 20v-9.17H0V7.5h2.5V4.58C2.5 2.227 3.984 0 7.5 0c1.416 0 2.5.186 2.5.186L9.863 3.33H7.705c-1.27 0-1.455.693-1.455 1.67v2.5H10l-.254 3.33H6.25V20H2.5z" />
	</svg>
)
